/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  ArMaterialStgLocList.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2024/11/28 Rayoo)niu : 新規作成
 *
 * Summary ArMaterialStgLocList画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */

import React, { useEffect, useState } from "react";
import API, { graphqlOperation } from "@aws-amplify/api";
import {
  listALLArMaterialStgLoc,
} from "../graphql/queries";
import Amplify,{Auth} from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container,Row,Col,InputGroup} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
    <div className="btn-group" role="group">
      {options.map((option) => (
        <button
          key={option.text}
          type="button"
          onClick={() => onSizePerPageChange(option.page)}
          className={`btn ${
            currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
            }`}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};

export const ArMaterialStgLocList = () => {
  const [ArMaterialStgLocList, setArMaterialStgLocList] = useState([]);
  const [progress, setProgress] = useState(false);
  const [ItemCodeList, setItemCodeList] = useState([]);
  const [StorageLocList, setStorageLocList] = useState([]);
  const [SalesGroupList, setSalesGroupList] = useState([]);
  const [UsageCategoryList, setUsageCategoryList] = useState([]);
  const [PlantList, setPlantList] = useState([]);
  const [SalesDocTypeList, setSalesDocTypeList] = useState([]);
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState({
    ItemCode: "",
    StorageLoc:"",
    SalesGroup:"",
    UsageCategory:"",
    Plant:"",
    SalesDocType:""
    })
  const searchItemCodeChange = (e, value) => {
    setSearchValue({ ...searchValue, ItemCode: value ? value.split(":")[0] : "" })
  }
  const searchStorageLocChange = (e, value) => {
    setSearchValue({ ...searchValue, StorageLoc: value ? value.split(":")[0] : "" })
  }
  const searchSalesGroupChange = (e, value) => {
    setSearchValue({ ...searchValue, SalesGroup: value ? value.split(":")[0] : "" })
  }
  const searchUsageCategoryChange = (e, value) => {
    setSearchValue({ ...searchValue, UsageCategory: value ? value : "" })
  }
  const searchPlantChange = (e, value) => {
    setSearchValue({ ...searchValue, Plant: value ? value.split(":")[0] : "" })
  }
  const searchSalesDocTypeChange = (e, value) => {
    setSearchValue({ ...searchValue, SalesDocType: value ? value : "" })
  }
   async function searchData() {
      let dataAll = [];
    try {
      const listInfo = await API.graphql(
        graphqlOperation(listALLArMaterialStgLoc, { limit: 10000 })
      );
      dataAll = listInfo.data.listALLArMaterialStgLoc["items"];
      let nextToken = listInfo.data.listALLArMaterialStgLoc.nextToken;
      while (nextToken !== null) {
        let InvDataSec = await API.graphql(
          graphqlOperation(listALLArMaterialStgLoc, {
            limit: 10000,
            nextToken: nextToken
          })
        );
        nextToken = InvDataSec.data.listALLArMaterialStgLoc.nextToken;
        for (
          let i = 0;
          i < InvDataSec.data.listALLArMaterialStgLoc.items.length;
          i++
        ) {
          dataAll.push(InvDataSec.data.listALLArMaterialStgLoc.items[i]);
        }
      }
  } catch (err) {
    console.log(err);
  }
    return dataAll
    }
    const searchBtn = async () => {
      setProgress(true)
      let arr = [];
      let dataAll = [];
      let obj = {};
      try {
        dataAll = await searchData()
        } catch (error) {
        console.log(error);
        }
        obj = searchValue;
        dataAll.forEach(item => {
        let flag = true
        if (Object.keys(obj).length !== 0) {
            for (let name in obj) {
              if (obj[name] !== "") {
                if (item[name]) {
                  if (!(item[name]).includes(obj[name])) {
                    flag = false;
                    break;
                  }
                } else {
                  flag = false
                  break;
                }
              }
            }
        }
        if (flag === true) {
          arr.push(item)
        }
        })
        arr = multiSort(arr,sortByItemCode)
        setArMaterialStgLocList(arr);
        setProgress(false)
    }
    const searchClear = async()=>{
        setProgress(true)
        let arr = [];
        try {
          arr = await searchData()
          } catch (error) {
            if (error.message === 'No current user') {
                //ユーザープールに障害が発生した場合
                console.log('User pool is invalid.Please reauthenticate.');
                //ログイン画面に戻る
                signOut();
            } else {
                //他のエラーを処理する
                console.log('An error occurred:', error);
            }
          }
          arr = multiSort(arr,sortByItemCode)
          setSearchValue({ItemCode: "",StorageLoc:"",SalesGroup:"",UsageCategory:"",Plant:"",SalesDocType:""})
          setArMaterialStgLocList(arr);
          setProgress(false)
    }
  const signOut = async () => {
      await Auth.signOut();
      try {
          await Auth.signOut();
      } catch (error) {
          console.log("error signing out: ", error);
      }
      document.location.reload();
    };
    const getTypePriority = (str) => {
      if (!str || str.trim() === "") return 99;
      const firstChar = str[0];
      if (/^[0-9]/.test(firstChar)) return 1;
      if (/^[a-zA-Z]/.test(firstChar)) return 2;
      if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
      if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
      return 5;
    };
    const sortByItemCode = (a, b) => {
      const nameA = a.ItemCode || "";
      const nameB = b.ItemCode || "";
      const priorityA = getTypePriority(nameA);
      const priorityB = getTypePriority(nameB);
      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }
      return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
    };
  const [scrollTableWidth,setscrollTableWidth] = useState('101%')
  function calculateZoomLevel() {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
    return Math.round(zoomLevel * 100);
  }
    const multiSort = (arr, ...sortFuncs)=> {
      return arr.sort((a, b) => {
        for (const func of sortFuncs) {
          const result = func(a, b);
          if (result !== 0) {
            return result;
          }
        }
        return 0;
      });
    }
    const SortListFun = (arr)=>{
      arr.sort((a,b)=>{
       if (!a) {
           return 1;
         } else if (!b) {
           return 1;
         } else {
           return a.localeCompare(b)
         }
       })
       return arr
   }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    const getArMaterialStgLocList = async () => {
      setProgress(true);
      let ArMaterialStgLocList = "";
      let listInfo = "";
      let itemCodeList = []
      let storageLocList = []
      let salesGroupList = []
      let usageCategoryList = []
      let plantList = []
      let salesDocTypeList = []
      try{
        listInfo = await API.graphql(
          graphqlOperation(listALLArMaterialStgLoc, { limit: 10000,})
        );
        ArMaterialStgLocList = listInfo.data.listALLArMaterialStgLoc["items"];
        let nextToken = listInfo.data.listALLArMaterialStgLoc.nextToken;

        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listALLArMaterialStgLoc, {
              limit: 10000,
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.listALLArMaterialStgLoc.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listALLArMaterialStgLoc.items.length;
            i++
          ) {
            ArMaterialStgLocList.push(InvDataSec.data.listALLArMaterialStgLoc.items[i]);
          }
        }
        for (let i = 0; i < ArMaterialStgLocList.length; i++) {
         if (ArMaterialStgLocList[i].ItemCode) {
          itemCodeList.push(ArMaterialStgLocList[i].ItemCode + ":" + ArMaterialStgLocList[i].Text)
          storageLocList.push(ArMaterialStgLocList[i].StorageLoc + ":" + ArMaterialStgLocList[i].StorageLocText)
          salesGroupList.push(ArMaterialStgLocList[i].SalesGroup + ":" + ArMaterialStgLocList[i].SalesGroupName)
          usageCategoryList.push(ArMaterialStgLocList[i].UsageCategory)
          plantList.push(ArMaterialStgLocList[i].Plant + ":" + ArMaterialStgLocList[i].PlantName)
          salesDocTypeList.push(ArMaterialStgLocList[i].SalesDocType)
         }
       }
       ArMaterialStgLocList = multiSort(ArMaterialStgLocList,sortByItemCode)
        setItemCodeList(Array.from(new Set(itemCodeList)))
        setStorageLocList(SortListFun(Array.from(new Set(storageLocList))))
        setSalesGroupList(SortListFun(Array.from(new Set(salesGroupList))))
        setUsageCategoryList(SortListFun(Array.from(new Set(usageCategoryList))))
        setPlantList(SortListFun(Array.from(new Set(plantList))))
        setSalesDocTypeList(SortListFun(Array.from(new Set(salesDocTypeList))))
        setArMaterialStgLocList(ArMaterialStgLocList);
        setProgress(false);
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      }catch (err) {
      setProgress(false);
          console.log(err);
      }
    }
    getArMaterialStgLocList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    { dataField: "ItemCode", text: "品目", headerStyle, sort: true, style: { margin: "0px", width: "160px",minWidth:"160px"} },
    { dataField: "Text", text: "テキスト", headerStyle, sort: true, style: { margin: "0px", width: "280px",minWidth:"280px" } },
    { dataField: "Plant", text: "プラント", headerStyle, sort: true, style: { margin: "0px", width: "90px",minWidth:"90px" } },
    { dataField: "PlantName", text: "プラント名", headerStyle, sort: true, style: { margin: "0px", width: "120px" ,minWidth:"120px"} },
    { dataField: "StorageLoc", text: "保管場所", headerStyle, sort: true, style: { margin: "0px", width: "90px",minWidth:"90px" } },
    { dataField: "StorageLocText ", text: "保管場所テキスト", headerStyle, sort: true, style: { margin: "0px", width: "160px",minWidth:"160px" } },
    { dataField: "SalesDocType", text: "販売伝票タイプ", headerStyle, sort: true, style: { margin: "0px", width: "140px",minWidth:"140px" } },
    { dataField: "SalesGroup", text: "営業 Grp", headerStyle, sort: true, style: { margin: "0px", width: "90px",minWidth:"90px" } },
    { dataField: "SalesGroupName", text: "営業グループ名称", headerStyle, sort: true, style: { margin: "0px", width: "160px",minWidth:"160px" } },
    { dataField: "UsageCategory", text: "使用区分", headerStyle, sort: true, style: { margin: "0px", width: "90px",minWidth:"90px" } },
  ];


  return (
    <Container
      style={{ backgroundColor: "", minWidth: "100%", minHeight: "74vh",position: "relative", }}
    >
      <Row
        style={{
           borderRadius: "0.25em",
           color: "purple",
           padding: "0.5em",
            }}
          >
        <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
        <Col>
            <h4 style={{
               textAlign: "left",
               color: "black",
               height: 30,
               width: '20%',
               borderLeft: "4px solid #804F29",
               paddingLeft: "4px",
               whiteSpace:"nowrap"}}>
          品目保管場所マスタ
          </h4>
        </Col>
        <div style={{ width: '80%', height: 192 }}>
               <div style={{ width: '90%',minWidth:"500px",height: 196, border: '2px solid rgb(191,191,191)', display: 'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"100px"}}
                         >品目
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={ItemCodeList}
                            value={searchValue.ItemCode}
                            name="ItemCode"
                            onChange={(e, value) => { searchItemCodeChange(e, value) }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"100px"}}
                         >プラント
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={PlantList}
                            value={searchValue.Plant}
                            name="Plant"
                            onChange={(e, value) => { searchPlantChange(e, value) }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"100px"}}
                          >保管場所
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={StorageLocList}
                              value={searchValue.StorageLoc}
                              maxLength ="20"
                              onChange={(e, value) => { searchStorageLocChange(e, value) }}
                              name="StorageLoc"
                              id="StorageLoc"
                              isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"100px"}}
                          >販売伝票タイプ
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={SalesDocTypeList}
                              value={searchValue.SalesDocType}
                              maxLength ="20"
                              onChange={(e, value) => { searchSalesDocTypeChange(e, value) }}
                              name="SalesDocType"
                              id="SalesDocType"
                              isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"100px"}}
                          >営業 Grp
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={SalesGroupList}
                              value={searchValue.SalesGroup}
                              maxLength ="20"
                              onChange={(e, value) => { searchSalesGroupChange(e, value) }}
                              name="SalesGroup"
                              id="SalesGroup"
                              isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"100px"}}
                          >使用区分
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={UsageCategoryList}
                              value={searchValue.UsageCategory}
                              maxLength ="20"
                              onChange={(e, value) => { searchUsageCategoryChange(e, value) }}
                              name="UsageCategory"
                              id="UsageCategory"
                              isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{margin:"auto"}}>
                    <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                      <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                  </div>
               </div>
        </div>
        </div>
        </Row>
        <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
          <BootstrapTable
            id="table"
            striped={true}
            hover={true}
            wrapperClasses="boo bg-white"
            bootstrap4
            keyField="id"
            data={ArMaterialStgLocList}
            columns={columns1}
            noDataIndication={"no results found"}
            pagination={paginationFactory(options)}
            headerClasses={classes.fixedTop}
            />
          </div>
          </div>
      </div>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: '60px',
          }}
        />
      </div>
    </Container>
  );
};

export default ArMaterialStgLocList;